import React from 'react';
import type { WidgetFC } from '../../common/Widget/types';
import AllMessagesList from './AllMessagesList/AllMessagesList';
import { MessageListTabItem } from '../MessageListTabs/MessageListTabs';
import type { MessageListWidgetExtendedProps } from '../types';

/**
 *  Message list for view all pages (blogs, kbs, forums)
 *
 *  @author Be.Abhijith
 */
const MessageListForViewAllWidget: WidgetFC<MessageListWidgetExtendedProps> = ({
  viewVariant,
  listVariant,
  pagerVariant,
  pageSize,
  panelType
}) => {
  const sortList: MessageListTabItem[] = [
    MessageListTabItem.MOST_RECENT,
    MessageListTabItem.MOST_REPLIES,
    MessageListTabItem.MOST_VIEWED,
    MessageListTabItem.MOST_KUDOED,
    MessageListTabItem.NEWEST
  ];

  return (
    <AllMessagesList
      viewVariant={viewVariant}
      pagerVariant={pagerVariant}
      listVariant={listVariant}
      pageSize={pageSize}
      panelType={panelType}
      sortOptions={sortList}
    />
  );
};

export default MessageListForViewAllWidget;
